<template>
  <div class="container carddiv">

    <div class="flex-container">
      <div class="flex-item card shadow" v-for="pcards in productlistcards">
        <img :src="`${myPicUrl}${pcards.valuespng}`" class="card-img-top" alt="" >
        <div  v-html="pcards.valuesphotodesc" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" class="flextextcss"></div>
      </div>
          
    </div>
  </div>
        
  </template>
  
  <script>
  require('@/globalDeclare.js');
  export default{

  props: ['productlistcards', 'piclisttheme', 'piclisttheme1'],
  data() {
    return {
        myPicUrl: '',
    }
  },

  mounted() {
    this.myPicUrl = myUrlPath
  }
  }
  </script>
  
  <style scoped>
.flextextcss {
  color: #003;
  font-size: 18px;
  font-weight: bold;
  margin-top: -20px;
}

  .piclistdesc {
    font-family: 'Times New Roman', Times, serif;
    font-weight: bold;
    font-size: 20px;
    color: #003;
  }

  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .carddiv {
      width: 100%;
    }
    .card {
      width: 94%;
      margin: 0 auto;
      margin-top: 30px;
      padding-bottom: 30px;
      height: auto;

    }
    .card-img-top {
      width: 50%;
      margin: 0 auto;
      padding: 30px;
    }
    .card-group {
      margin-top: 200px;
      width: 100%
    }

   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    
    .carddiv {
      width: 100%;
    }
    .card {
      width: 94%;
      margin: 0 auto;
      margin-top: 30px;
      padding-bottom: 30px;
      height: auto;

    }
    .card-img-top {
      width: 50%;
      margin: 0 auto;
      padding: 30px;
    }
    .card-group {
      margin-top: 200px;
      width: 100%
    }
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .flex-container {
      display: flex;
      flex-flow: row wrap;
      height: 650px;
      width: 100%;
      /* Then we define how is distributed the remaining space */

    }
    
    .flex-item {
      padding: 5px;
      width: 50%;
      height: 215px;
      line-height: 150px;
      color: white;
      font-weight: bold;
      font-size: 3em;
      text-align: center;
      margin: 0 auto;
    }
    .card {
      margin-bottom: -50px
    }
    .card-img-top {
      width: 100%;
    }
    .flextextcss {
      margin-top: -80px;
      color: #003;
      font-size: 14px;
    }
    
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
    .flex-container {
      display: flex;
      flex-flow: row wrap;
      height: 650px;
      width: 100%;
      /* Then we define how is distributed the remaining space */

    }
    
    .piccardsection {
      margin-top: -600px;
     }
  

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 215px;
      line-height: 150px;
      color: white;
      font-weight: bold;
      font-size: 3em;
      text-align: center;
      margin: 0 auto;
    }
    .card {
      margin-bottom: -50px
    }
    .card-img-top {
      width: 100%;
    }
    .flextextcss {
      margin-top: -80px;
      color: #003;
      font-size: 14px;
    }
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
    .flex-container {
      display: flex;
      flex-flow: row wrap;
      height: 650px;
      width: 100%;
      /* Then we define how is distributed the remaining space */

    }
    
    .piccardsection {
      margin-top: -600px;
     }
  

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 215px;
      line-height: 150px;
      color: white;
      font-weight: bold;
      font-size: 3em;
      text-align: center;
      margin: 0 auto;
    }
    .card {
      margin-bottom: -50px
    }
    .card-img-top {
      width: 60%;
    }
    .flextextcss {
      margin-top: -80px;
      color: #003;
      font-size: 14px;
    }
  }
   
  </style>